import { useEffect, useState } from 'react'

type TimeLeft = {
  minutes: number
  seconds: number
  total: number
}

/**
 * Simple in-page urgency countdown. Starts at `startSeconds` and
 * ticks down to zero once, then stops at zero.
 */
export function useCountdown(startSeconds: number): TimeLeft {
  const [remaining, setRemaining] = useState(startSeconds)

  useEffect(() => {
    if (remaining <= 0) return
    const id = window.setInterval(() => {
      setRemaining((prev) => (prev <= 1 ? 0 : prev - 1))
    }, 1000)
    return () => window.clearInterval(id)
  }, [remaining])

  return {
    minutes: Math.floor(remaining / 60),
    seconds: remaining % 60,
    total: remaining,
  }
}
